import { Block, Content, Li, Title } from "./styled";

const Skillset = () => {
    return (
        <>
            <Block>
                <Title>My skillset includes</Title>
                <Content>
                    <Li>TypeScript</Li>
                    <Li>JavaScript: ES6+</Li>
                    <Li>Jest</Li>
                    <Li>React</Li>
                    <Li>React Router</Li>
                    <Li>React Hooks</Li>
                    <Li>Redux Toolkit</Li>
                    <Li>Redux Saga</Li>
                    <Li>Zustand</Li>
                    <Li>Vite</Li>
                    <Li>Webpack</Li>
                    <Li>Next.js</Li>
                    <Li>OOP & Patterns</Li>
                    <Li>Node.js</Li>
                    <Li>Canvas</Li>
                    <Li>Immutability</Li>
                    <Li>Semantic & accessible HTML</Li>
                    <Li>Express (NodeJS)</Li>
                    <Li>PostgreSQL</Li>
                    <Li>Styled-Components</Li>
                    <Li>Linaria</Li>
                    <Li>CSS</Li>
                    <Li>SASS / SCSS</Li>
                    <Li>REST API (fetch, axios)</Li>
                    <Li>Promises, Async/Await</Li>
                    <Li>Error handling</Li>
                    <Li>JWT</Li>
                    <Li>OAuth</Li>
                    <Li>Web sessions</Li>
                    <Li>Optimization</Li>
                    <Li>Lazy loading</Li>
                    <Li>Blob handling</Li>
                    <Li>Telegram Bots</Li>
                    <Li>GIT</Li>
                    <Li>GitHub</Li>
                    <Li>Responsive Web Design</Li>
                    <Li>NPM</Li>
                    <Li>Yarn</Li>
                    <Li>Markdown</Li>
                    <Li>BEM (CSS convention)</Li>
                    <Li>Agile (Scrum)</Li>
                    <Li>Jira</Li>
                    <Li>Trello</Li>
                    <Li>Figma</Li>
                    <Li>Adobe Photoshop</Li>
                </Content>
            </Block>
            <Block>
                <Title>What I want to learn next</Title>
                <Content>
                    <Li>React Native</Li>
                    <Li>Nest.js</Li>
                    <Li>WebGL</Li>
                    <Li>MongoDB</Li>
                    <Li>TanStack Query</Li>
                    <Li>Cypress</Li>
                </Content>
            </Block>
        </>
    );
};

export default Skillset;